import { Break, TimeSlotType, WorkingHours, Shift } from "../types";

// quando orario salvato contiene una sola cifra nelle ore, aggiunge 0 iniziale
export const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    const formattedHours = hours.padStart(2, '0');
    const formattedMinutes = minutes.padStart(2, '0');
    return `${formattedHours}:${formattedMinutes}`;
};

export function validateTimeSlots(
    workStartTime: string,
    workEndTime: string,
    time_slots: TimeSlotType[],
) {
 
    const formattedWorkStartTime = formatTime(workStartTime);
    const formattedWorkEndTime = formatTime(workEndTime);

    // validate time_slots
    // if (formattedWorkEndTime < formattedWorkStartTime) {
    //     throw new Error("L'orario di fine deve essere successivo all'orario di inizio.");
    // }

    const overlaps = time_slots.some(timeSlot => {
        const existingStartTime = formatTime(timeSlot.start_at);
        const existingEndTime = formatTime(timeSlot.end_at);

    const isOverlap =
        (formattedWorkStartTime >= existingStartTime && formattedWorkStartTime < existingEndTime) ||
        (formattedWorkEndTime > existingStartTime && formattedWorkEndTime <= existingEndTime) ||
        (formattedWorkStartTime <= existingStartTime && formattedWorkEndTime >= existingEndTime);

        return isOverlap;
    });

    if (overlaps) {
        throw new Error('La nuova fascia oraria si sovrappone ad una già esistente.');
    }
}

export function validateBreak(
    workStartTime: string,
    workEndTime: string,
    pauseTime: Break,
    pauseTimes: Break[],
) {

    const formattedPauseStartTime = formatTime(pauseTime.start_at);
    const formattedPauseEndTime = formatTime(pauseTime.end_at);

    if (!formattedPauseStartTime || !formattedPauseEndTime) { 
        throw new Error("Inserisci un orario di inizio e di fine per la pausa.");
    }

    // L'orario di fine pausa deve essere maggiore dell'orario di inizio pausa.
    if (formattedPauseStartTime >= formattedPauseEndTime) {
        throw new Error("L'orario di fine pausa deve essere maggiore dell'orario di inizio pausa.");
    }
    
    // validate break
    if (formattedPauseStartTime < formatTime(workStartTime) || formattedPauseEndTime > formatTime(workEndTime)) {
        throw new Error ("La fascia oraria della pausa deve essere compresa nella fascia oraria di lavoro.");
    }
  
    const isOverlap = pauseTimes.some((pause) => {
        if (pause === pauseTime) return false;
        const formattedExistingStartTime = formatTime(pause.start_at);
        const formattedExistingEndTime = formatTime(pause.end_at);
        return (
            (formattedPauseStartTime >= formattedExistingStartTime && formattedPauseStartTime < formattedExistingEndTime) ||
            (formattedPauseEndTime > formattedExistingStartTime && formattedPauseEndTime <= formattedExistingEndTime) ||
            (formattedPauseStartTime <= formattedExistingStartTime && formattedPauseEndTime >= formattedExistingEndTime)
        );
    });
    
    if (isOverlap) {
        throw new Error ("La fascia oraria della pausa si sovrappone ad una pausa già esistente.");
    }
  
    // if (formattedPauseStartTime >= formattedPauseEndTime) {
    //     throw new Error ("L'orario di fine pausa deve essere maggiore dell'orario di inizio pausa.");
    // } 

    // if (!formattedPauseStartTime || !formattedPauseEndTime) { 
    //     throw new Error("Inserisci un orario di inizio e di fine per la pausa.");
    // }
}



// export function validateBreaks(
//     workStartTime: string,
//     workEndTime: string,
//     pauseTimes: Break[]
// ) {
//     // validate breaks
//     const isPauseWithinTimeSlot = pauseTimes.some(pause => {
//         return (
//             pause.start_at >= workStartTime &&
//             pause.end_at <= workEndTime
//         );
//     });
   
//     if (pauseTimes.length > 0 && !isPauseWithinTimeSlot) {
//         throw new Error('Tutte le pause devono essere incluse nella fascia oraria di lavoro.');
//     } 

//     pauseTimes.map(pauseTime => validateBreak(
//         workStartTime, workEndTime, pauseTime, pauseTimes
//     ));
// }

// MODIFICATA VALIDATE BREAKS E COMMENTATA FUNZIONE PRECEDENTE. CONTROLLARE PRIMA OVUQNUE VIENE UTILIZZATA ED EVENTUALMENTE CANCELLARLA SE OK LA NUOVA
export function validateBreaks(
    workStartTime: string,
    workEndTime: string,
    pauseTimes: Break[]
) {
    if (!workStartTime || !workEndTime) {
        throw new Error("L'orario di inizio e di fine del lavoro sono obbligatori.");
    }

    const areAllPausesValid = pauseTimes.every(pause => {
        const formattedPauseStartTime = formatTime(pause.start_at);
        const formattedPauseEndTime = formatTime(pause.end_at);
        return (
            formattedPauseStartTime >= formatTime(workStartTime) &&
            formattedPauseEndTime <= formatTime(workEndTime)
        );
    });

    if (!areAllPausesValid) {
        throw new Error('Tutte le pause devono essere incluse nella fascia oraria di lavoro.');
    }

    pauseTimes.forEach(pauseTime => validateBreak(
        workStartTime, workEndTime, pauseTime, pauseTimes
    ));
}

export const convertToShifts = (workinghourid: number, workingHours: WorkingHours[]): Shift[] => {
    const workingHour = workingHours.find(wh => wh.id === workinghourid)
    if (!workingHour || !workingHour.time_slots || workingHour.time_slots.length === 0) {
        return [];
    }

    return workingHour.time_slots.map((slot: any) => ({
        workStartTime: slot.start_at,
        workEndTime: slot.end_at,
        breaks: (slot.breaks || []),
        editable: true
    }));
};

export const convertWorkingHourToShifts = (workinghourid: number, workingHours: WorkingHours[]) => {
    const workingHour = workingHours.find(wh => wh.id === workinghourid)
    if (!workingHour || !workingHour.time_slots || workingHour.time_slots.length === 0) {
        return [];
    }

    return workingHour.time_slots.map((slot: any) => ({
        start_at: slot.start_at,
        end_at: slot.end_at,
        breaks: (slot.breaks || []),
        editable: true,
        duration: slot.duration,
    }));
};
  


const toMinutes = (hhmm: string): number | null => {
    if (!hhmm || typeof hhmm !== "string") return null;
    const t = formatTime(hhmm);
    const [hStr, mStr] = t.split(":");
    const h = Number(hStr);
    const m = Number(mStr);
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
};

const normalizeOnShiftTimeline = (
    tMin: number,
    workStartMin: number,
    crossesMidnight: boolean
): number => {
    if (!crossesMidnight) return tMin;
    // se è "prima" dello start, allora è nel giorno successivo => +1440
    return tMin < workStartMin ? tMin + 1440 : tMin;
};

/**
 * Validazione pausa per turni che possono attraversare mezzanotte.
 * - Se NON attraversa mezzanotte, puoi continuare a usare validateBreak.
 * - Se attraversa mezzanotte, questa funzione valida correttamente l'inclusione e le sovrapposizioni.
 */
export const validateBreakCrossMidnight = (
  workStartTime: string,
  workEndTime: string,
  pauseTime: Break,
  pauseTimes: Break[]
) => {
  const ws = toMinutes(workStartTime);
  const we0 = toMinutes(workEndTime);
  const ps0 = toMinutes(pauseTime?.start_at);
  const pe0 = toMinutes(pauseTime?.end_at);
  

  if (ws == null || we0 == null || ps0 == null || pe0 == null) {
    throw new Error("Inserisci un orario di inizio e di fine per la pausa.");
  }

  const crossesMidnight = ws > we0;

  // timeline fine turno: se cross, +1440
  const we = crossesMidnight ? we0 + 1440 : we0;

  const ps = normalizeOnShiftTimeline(ps0, ws, crossesMidnight);
  const pe = normalizeOnShiftTimeline(pe0, ws, crossesMidnight);
  
  // fine deve essere dopo inizio sulla timeline
  if (ps >= pe) {
    throw new Error("L'orario di fine pausa deve essere maggiore dell'orario di inizio pausa.");
  }

  // pausa dentro la finestra di lavoro
  if (ps < ws || pe > we) {
    throw new Error("La fascia oraria della pausa deve essere compresa nella fascia oraria di lavoro.");
  }

  // overlap con altre pause
  const isOverlap = pauseTimes.some((p) => {
    if (p === pauseTime) return false;

    const os0 = toMinutes(p.start_at);
    const oe0 = toMinutes(p.end_at);
    if (os0 == null || oe0 == null) return false;

    const os = normalizeOnShiftTimeline(os0, ws, crossesMidnight);
    const oe = normalizeOnShiftTimeline(oe0, ws, crossesMidnight);

    return (
      (ps >= os && ps < oe) ||
      (pe > os && pe <= oe) ||
      (ps <= os && pe >= oe)
    );
  });

  if (isOverlap) {
    throw new Error("La fascia oraria della pausa si sovrappone ad una pausa già esistente.");
  }
};